/**
 * @file paddle Wave Summit 2020 内容框
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import classNames from 'classnames';
import {IContentPanelProps} from './types';


const ContentPanel: React.FC<IContentPanelProps> = (props) => {
    const {
        children,
        title,
        titleColors,
        subTitle,
        backgroundNode,
        type
    } = props;

    return (
        <div
            className={classNames(
                'paddle-ws2020-content-panel',
                type ? `paddle-ws2020-content-panel-style-${type}` : undefined
            )}
        >
            {backgroundNode}
            <div className="paddle-ws2020-content-panel-header">
                <div className="paddle-ws2020-content-panel-header-btn" />
                <div className="paddle-ws2020-content-panel-header-btn" />
                <div className="paddle-ws2020-content-panel-header-btn" />
            </div>
            <div className="paddle-ws2020-content-panel-body">
                {!!titleColors
                && (
                    <div className="paddle-ws2020-content-panel-title-colors">
                        <span>{titleColors}</span>
                    </div>
                )}
                {!!title
                && (
                    <div className="paddle-ws2020-content-panel-title">
                        <span>
                            {title}
                            <div className="paddle-ws2020-content-panel-title-line" />
                        </span>
                    </div>
                )}
                {!!subTitle
                && (
                    <div className="paddle-ws2020-content-panel-sub-title">
                        {subTitle}
                    </div>
                )}
                {children}
            </div>
        </div>
    );
};

export default ContentPanel;
